import React from "react";
import Modal from "react-bootstrap/Modal";
import Common_Back_Btn from "../../common_components/common_back_btn/Common_Back_Btn";
import Black_Submit_Btn from "../../common_btn/black_submit_btn/Black_Submit_Btn";
import "./Certification_Modal.css";

const Multi_Image_Show_Modal = ({
  show,
  onHide,
  modalHeadingText,
  imgSrc,
  btnText,
  title,
}) => {
  const handleDownloadInvoice = async (invoicePath) => {
    if (!invoicePath) {
      alert("Invoice not available");
      return;
    }

    try {
      const fileUrl = `${invoicePath}`;

      // Fetch the file as blob
      const response = await fetch(fileUrl, { mode: "cors" });
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();

      // Create a temporary object URL from blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${title || "Certificate"}.pdf`); // you can make this dynamic
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download invoice");
    }
  };

  return (
    <Modal
      className="common_modal Certification_Modal"
      centered
      show={show}
      onHide={onHide}
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>
          <div className="back_div" onClick={onHide}>
            <Common_Back_Btn backText="File Download" />
          </div>
          {modalHeadingText}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="cerificate_img_holder">
          {Array.isArray(imgSrc) && imgSrc.length > 0 ? (
            imgSrc.map((src, index) => {
              const file = src?.file ||src?.document_path||  "";
              const fileUrl = process.env.REACT_APP_IMG_URL + file;

              const isPDF = file.endsWith(".pdf");
              const isImage =
                file.endsWith(".jpg") ||
                file.endsWith(".jpeg") ||
                file.endsWith(".png") ||
                file.endsWith(".webp");

              const isWord = file.endsWith(".doc") || file.endsWith(".docx");
              const isExcel = file.endsWith(".xls") || file.endsWith(".xlsx");

              return (
                <div key={index} className="certificate_item">
                  {/* ✅ PDF */}
                  {isPDF && (
                    <iframe
                      src={fileUrl}
                      className="certificate_img"
                      title={`PDF ${index}`}
                      width="100%"
                      height="400px"
                    />
                  )}

                  {/* ✅ IMAGE */}
                  {isImage && (
                    <img
                      src={fileUrl}
                      className="certificate_img"
                      alt={`Image ${index}`}
                    />
                  )}

                  {/* ✅ WORD FILE */}
                  {isWord && (
                    <div className="file_preview">
                      <p>📄 Word File</p>
                      <a
                        href={fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Open / Download
                      </a>
                    </div>
                  )}

                  {/* ✅ EXCEL FILE */}
                  {isExcel && (
                    <div className="file_preview">
                      <p>📊 Excel File</p>
                      <a
                        href={fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Open / Download
                      </a>
                    </div>
                  )}

                  {/* ✅ Download Button */}
                  <div className="btn_holder">
                    <Black_Submit_Btn
                      btnText="Download"
                      onClick={() => handleDownloadInvoice(fileUrl)}
                    />
                  </div>
                </div>
              );
            })
          ) : imgSrc ? (
            <p>Single file handling (optional)</p>
          ) : (
            <p>No certificate available</p>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Multi_Image_Show_Modal;
